import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production this would forward to Sentry / Datadog / etc.
    // eslint-disable-next-line no-console
    console.error("UI error boundary:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="w-12 h-12 rounded-full bg-red-50 text-red-600 grid place-items-center mx-auto mb-4">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <h2 className="font-display text-xl font-medium text-slate-900">Algo deu errado nesta tela</h2>
          <p className="text-sm text-slate-500 mt-2">
            Nossa equipe foi notificada. Tente recarregar ou voltar ao dashboard.
          </p>
          <div className="flex justify-center gap-2 mt-5">
            <Button variant="outline" className="border-slate-200" onClick={() => window.location.href = "/app/dashboard"}>Ir ao Dashboard</Button>
            <Button className="bg-blue-700 hover:bg-blue-800" onClick={this.reset}>Tentar novamente</Button>
          </div>
        </div>
      </div>
    );
  }
}
